import React from 'react'
import type { KambiSportsSelection } from '@mobi/betslip/types'
import { PriceChange } from '@core/Components/Text/utils'
import { getPriceFromKambiSportsSelection } from '@core/Areas/Quickbet/helpers/selectionsKambi'
import { LegInfoWithPriceComponent } from '../LegInfoWithPriceComponent'

export const KambiSportsLegInfo: React.FC<{
  selection: KambiSportsSelection
  isActive: boolean
  priceChange: PriceChange
}> = ({ selection, isActive, priceChange }) => {
  const legInfoLabel =
    selection.betSelectionType === 'single'
      ? 'Single'
      : selection.betSelectionType === 'same-game-multi'
        ? 'Same Game Multi'
        : 'Multi'

  return (
    <LegInfoWithPriceComponent
      legType={legInfoLabel}
      price={getPriceFromKambiSportsSelection(selection)}
      isActive={isActive}
      boostAmount={0}
      priceChange={priceChange}
    />
  )
}

// =============
// Local Helpers
// =============
